 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		146: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "" + ({"9":"sentry-js","10":"share-buttons","18":"share-pane","23":"share-count","26":"ga-skipprecache","29":"body","32":"newsletter-inline","38":"newsletter","43":"article-list-card","44":"video-list-card","46":"tech-city-card","47":"newsletter-desktop","48":"timeline-vue","50":"hammerjs","103":"preview-nav-button","134":"preview-nav-button-group","142":"howler","144":"timeline","145":"jwp"}[chunkId]||chunkId) + "." + {"0":"a9c2b88581669d699b8b","1":"cf83ea6f6ceca1082744","2":"7ee0cba799e26df1eddf","3":"7778274dae537dc758f2","4":"2795500c81c0a20e0769","5":"973bf79f03ede90c073b","6":"d26fae1dcb1cdafa9f57","7":"dfb2d6dafa95c6f98c48","8":"99b8d38b8c43ead8a526","9":"f43c5cb327d745fa7b41","10":"5bfcb5b29fca99ef6120","11":"8ee91976421c68af7fba","12":"cd767a6438b4b88b0160","13":"2e419c7c18514df8829c","14":"687150df3ad3c1cab691","15":"9b80b6e48c975291c0e5","16":"a7d19b5ae0a9ff297923","17":"05c1421910d3e242e5fa","18":"71eece130e48ea38b636","19":"c4e6ccbc20d81a160c3f","20":"27f7fbeaa1700d72923a","21":"1b930e9e3215c5af828b","22":"98903eab5566857b34d8","23":"224dfd5c6da01b941ae0","24":"3fdcd17ec1180b44ab93","25":"72bbca84f6180f1dbbdd","26":"f1805315da003ba0cb7d","29":"d8dee2e0b28bb9b4b3ba","30":"e835f343817d0f4b1dd6","31":"833acb5f65126fe83907","32":"e2a56c86f6c7065ca469","33":"4866625a1ce18d93107a","34":"0268a93b9f2abfef3f2b","35":"ff72037bf77acc576826","36":"75cc1d55b69a12ac2d04","37":"81812af11bf2db620bdf","38":"01e2c43cbe591c241489","39":"9b4f18c6a591ccf5873f","40":"bb4376f665ab10e044b7","41":"b8c27501f0e211f13513","42":"b49f384aa5ffae26f18f","43":"ec65cac98323fcd6a6b1","44":"e7da54f7a248a4c5ae68","45":"8104d2e7f08beefc2f1c","46":"6eb9737be14e5e523f15","47":"8f16d35d4169bdab2b4b","48":"a886004d330772fdd4c6","49":"71fc1896e136ec7f5b54","50":"96fbe2552133d9a501b1","51":"b0a85e3faca0791765a4","52":"a5b9b2cc354bd5254e16","53":"4dc54898570ca09bb293","54":"879c515486a468ca68c2","55":"4652772bfe4385601307","56":"fb6fe3dda5d0d2db333a","57":"ded84ff31c04c927f414","58":"9d808e87d1b09b425208","59":"f5d1457aaf8795ce8988","60":"c10368e230e7ec29c888","61":"602da5eeebb6e48d08c8","62":"7b66cb57ec85850a0284","63":"aae8c850415e99ce86c8","64":"208683f421a69cd41b53","65":"005608cde921695f3e31","66":"3352233182d424fa93ec","67":"8d589be6848d93424b20","68":"6cbca1353d1293405461","69":"5dbdd82308e5e2e0dd96","70":"722ad53f748f07145e3d","71":"a08a8a56729adf53a0bd","72":"85eb7d63bb9e6f1f1ce8","73":"d26eab2f014b2dcbc23b","74":"934f180c97b6d52c1ffb","75":"7df67d5707119f800f77","76":"e59e0e396c73c4b331e1","77":"1817c830795edd4f2588","78":"698a357f14811f622f3d","79":"b1a0effc96b050aa9ac9","80":"6367f193e900bc10792c","81":"67642581db26f2c91a80","82":"89507a4b4429221b2be8","83":"9297b61a4a9c530ff947","84":"0b04e018e63b7d7edf18","85":"a5d5ad4bd241be5d2f36","86":"530ea7476476dfb42334","87":"ebe2aa6a5e05618d443f","88":"fc682e9c9a29a74f58a8","89":"b09cf5392b0579f41f1f","90":"28f1da4fe8adfdd0a9f9","91":"193671369b208a68c728","92":"21d9a9cfe76dbea8f52a","93":"d62468c8899d363b2a28","94":"d9288c7252761891e866","95":"152a8bd383602829126a","96":"ceb724db420c51dbf001","97":"4725bf01ff9cf0043cb3","98":"224017bfa87354214de5","99":"855c4ef138030e5de3d7","100":"636f9ef7a67db95c66bc","101":"97c8a531263ca0e4fbee","102":"87580af87b7437d2ea28","103":"88815eff63f4a198ddf6","104":"837dae308446f7453c10","105":"0b19c90482a5cd145901","106":"1240f75c91db2f8c91a6","107":"4e5e27dfbd37f0230ee2","108":"d96c42dfefa391ba2bba","109":"0e1b8ba0a27d8b7c112a","110":"00272500cd76b74c51d8","111":"43943ea6770e06bfa5e1","112":"67cede6d74362f720320","113":"ed08d4dc752e900eebac","114":"5632b08911d23a79335c","115":"eeb997694c4af140ed8e","116":"89dec079e2ce09214c47","117":"7cf8cc58f7a5db9bb083","118":"b3432738f5f557b4280e","119":"0b2e7c78e49d041cec99","120":"d2e3ab992b3668af86f7","121":"0955e015e1f87d8373e4","122":"e370fe5f56d8276bb9c5","123":"4b89af9647150902aed6","124":"70d9dd28cc33b430c3bb","125":"ef7f2e3a45097894476f","126":"c1ed0ce60b58fa95406e","127":"c74491077d741f8c4b77","128":"58a5e51d0a0182dcb1f2","129":"39c718eca6e36f74ef96","130":"4af37bd9465a35f2ba6c","131":"86daed1051750454a55d","132":"5d65e6d3393becf3de51","133":"81a3204c41a4ae6b48e0","134":"209169c9e4a6bc3fbf29","135":"f291624a841f483a71b1","136":"020d5cc7218a3469213e","137":"6fa818271f7d3afa836e","138":"b0c7ebfb0d27c1d68356","139":"fefd3f58c063f60e365a","140":"b94b77b300138b9781c8","141":"fe61ab3e29b56f8626e3","142":"488d68709ce6800e8f3d","143":"7326444c45af9f222a01","144":"83f34d292d20339e7b44","145":"c3581a2ff993f3034a9c"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.abacusnews.com/production/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap 341e5779c4c0e7376bf0